/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Outreach_Description1Inputs */

const en_coinvestments_outreach_description1 = /** @type {(inputs: Coinvestments_Outreach_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite organisations and manage access to this deal. Send email invitations or manually unlock access for deals shared outside the platform.`)
};

/**
* | output |
* | --- |
* | "Invite organisations and manage access to this deal. Send email invitations or manually unlock access for deals shared outside the platform." |
*
* @param {Coinvestments_Outreach_Description1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_outreach_description1 = /** @type {((inputs?: Coinvestments_Outreach_Description1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Outreach_Description1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_outreach_description1(inputs)
});
export { coinvestments_outreach_description1 as "coInvestments_outreach_description" }